import { render, staticRenderFns } from "./TripTemplateFormInput.vue?vue&type=template&id=f2f99ca2&scoped=true&"
import script from "./TripTemplateFormInput.vue?vue&type=script&lang=js&"
export * from "./TripTemplateFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f99ca2",
  null
  
)

/* custom blocks */
import block0 from "./TripTemplateFormInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports